import React from 'react'
import PropTypes from 'prop-types'
import MarkerCSSTransformed from './MarkerCSSTransform'

// FEATURE: (1) Animate marker

/**
 * Marker class to locate companies on the map
 */
const Marker = ({
  latitude,
  longitude,
  size,
  offsetTop = 0,
  offsetLeft = 0,
  children,
  style,
  className,
}) => {
  const offset = size ? -size / 2 : 0

  return (
    <MarkerCSSTransformed
      latitude={latitude}
      longitude={longitude}
      offsetTop={!size ? offsetTop : offset}
      offsetLeft={!size ? offsetLeft : offset}
      captureScroll={true}
      style={style}
      className={className}
    >
      {children}
    </MarkerCSSTransformed>
  )
}

export default Marker

Marker.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  size: PropTypes.number,
  offsetLeft: PropTypes.number,
  offsetTop: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.string,
}
